/* eslint-disable */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim
* Coded by www.creative-tim.com
=========================================================
*/

import { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import axios from "services/axiosConfig";
import { normalizeRole, normalizeUsername } from "utils/auth";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";
import Alert from "@mui/material/Alert";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Typography from "@mui/material/Typography";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const [loginError, setLoginError] = useState("");

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  // Función para manejar el éxito de autenticación con Google
  const handleSuccess = async (credentialResponse) => {
    setLoginError("");
    const tokenId = credentialResponse.credential;
    console.log("Google credential:", tokenId);
    try {
      const res = await axios.post("/auth/google-login", { token: tokenId });
      localStorage.setItem("token", res.data.accessToken);
      const role = normalizeRole(res.data?.user?.role);
      if (role) localStorage.setItem("role", role);
      else localStorage.removeItem("role");
      const username = normalizeUsername(res.data?.user?.username);
      if (username) localStorage.setItem("username", username);
      else localStorage.removeItem("username");
      window.location.href = "/dashboard";
    } catch (err) {
      setLoginError(err.response?.data?.message || "Error al iniciar sesión, usuario no autorizado");
      console.error("Error al iniciar sesión, usuario no autorizado", err);
    }
  };

  // Función para manejar errores de Google Login
  const handleError = () => {
    console.log("Login fallido");
    setLoginError("No se pudo iniciar sesión con Google. Intentá nuevamente.");
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white">
            Iniciar sesión
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            {/* <MDBox mb={2}>
              <MDInput type="email" label="Email" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" label="Contraseña" fullWidth />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Recordarme
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth>
                Iniciar sesión
              </MDButton>
            </MDBox> */}

            <MDBox>
              <MDTypography
                variant="h6"
                color="text"
              >
                Usa tu cuenta de google para iniciar sesión
              </MDTypography>
            </MDBox>

            {/* Botón de Google Login */}
            <MDBox mt={3} mb={4} textAlign="center">
              <GoogleLogin locale="es" onSuccess={handleSuccess} onError={handleError} />
              {loginError && (
                <Alert severity="error" sx={{ mt: 2, textAlign: "left" }}>
                  {loginError}
                </Alert>
              )}
            </MDBox>

            {/* <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                ¿No tiene una cuenta?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Registrarse
                </MDTypography>
              </MDTypography>
            </MDBox> */}
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
